import Devices from './device-cards.vue'
export default (Application) => {
    let vce = Application.proc.make('VueCustomElement')
    vce.createApp({
        name: "device-cards",
        alias: "设备管理卡片",
        category: "主题", 
        singleton: false,
        showTitle: false
    }, Devices)
}